import {Component} from 'lowkey-component';

import {isScrolledOver} from '@lib/utils';

export class Image extends Component {
  observer: IntersectionObserver | null = null;
  picture: HTMLPictureElement | null = null;

  constructor(element: HTMLDivElement) {
    super(element);
    this.onIntersection = this.onIntersection.bind(this);
  }

  didMount() {
    this.picture = this.element.querySelector('figure') as HTMLPictureElement;
    this.observer = new IntersectionObserver(this.onIntersection, {
      rootMargin: '0px',
      threshold: [0, 0.2],
    });
    this.observer.observe(this.picture);
  }

  didUnmount() {
    this.observer?.disconnect();
  }

  onIntersection(entries: IntersectionObserverEntry[]) {
    for (const entry of entries) {
      if (isScrolledOver(this.element)) {
        this.element.classList.add('viewed');
      }
      // 画面の下でintersectionしたかどうか
      const isBottomArea = entry.boundingClientRect.top > 0;
      if (isBottomArea) {
        if (!entry.isIntersecting) {
          this.element.classList.remove('viewed');
        }
        if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
          this.element.classList.add('viewed');
        }
      }
    }
  }
}
